import * as React from "react";
import { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
  useRouteError,
} from "react-router-dom";
import MainPage from "../pages/main-page";
import AppLayout from "../app-layout";
import NotFoundPage from "../pages/not-found-page/not-found-page";
import PageLoading from "../page-loading/page-loading";
import ErrorMessage from "../error-message";

const ProductPage = lazy(() => import("../pages/product-page"));
const CataloguePage = lazy(() => import("../pages/catalogue-page"));
const ContactsPage = lazy(() => import("../pages/contacts-page/contacts-page"));
const PolicyPage = lazy(() => import("../pages/policy-page"));
const AboutCompanyPage = lazy(() => import("../pages/about-company-page"));

function ErrorBoundary() {
  const error = useRouteError();
  console.error(error);

  const errorText =
    error?.data?.message ||
    error?.statusText ||
    error?.message ||
    "Произошла непредвиденная ошибка";

  return (
    <div style={{ padding: "80px 20px" }}>
      <ErrorMessage
        title="Что-то пошло не так"
        message={errorText}
        actionLabel="Перезагрузить страницу"
        onAction={() => window.location.reload()}
        className="error-message--page"
      />
    </div>
  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<AppLayout />} errorElement={<ErrorBoundary />}>
        <Route index element={<MainPage />} />
        <Route
          path="catalogue/"
          exact
          element={
            <Suspense fallback={<PageLoading />}>
              <CataloguePage />
            </Suspense>
          }
        />
        <Route
          path="product/:title_id"
          element={
            <Suspense fallback={<PageLoading />}>
              <ProductPage />
            </Suspense>
          }
        />
        <Route
          path="contacts"
          element={
            <Suspense fallback={<PageLoading />}>
              <ContactsPage />
            </Suspense>
          }
        />
        <Route
          path="personal_information"
          element={
            <Suspense fallback={<PageLoading />}>
              <PolicyPage />
            </Suspense>
          }
        />
        <Route
          path="aboutus"
          element={
            <Suspense fallback={<PageLoading />}>
              <AboutCompanyPage />
            </Suspense>
          }
        />
        <Route path="link" element={<MainPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </>,
  ),
);

const App = () => <RouterProvider router={router} />;

export default App;
